import { Address, AddressCountries } from '@src/types'

export type CheckoutAddress = Pick<
  Address,
  'name' | 'street' | 'street2' | 'city' | 'state' | 'country' | 'zipCode'
>

const REQUIRED_CHECKOUT_ADDRESS_FIELDS = ['name', 'country', 'street', 'city', 'zipCode'] as const
const REQUIRED_CHECKOUT_ADDRESS_FIELDS_WITH_STATE = [
  ...REQUIRED_CHECKOUT_ADDRESS_FIELDS,
  'state',
] as const

const requiresState = (country?: CheckoutAddress['country']) => country !== AddressCountries.Gb

export const getMissingCheckoutAddressFields = (address?: CheckoutAddress) => {
  const requiredFields = requiresState(address?.country)
    ? REQUIRED_CHECKOUT_ADDRESS_FIELDS_WITH_STATE
    : REQUIRED_CHECKOUT_ADDRESS_FIELDS

  if (!address) {
    return requiredFields
  }

  return requiredFields.filter((field) => !address[field]?.trim())
}
